import { render, staticRenderFns } from "./ProjectNavigation.vue?vue&type=template&id=131f7e45&scoped=true"
import script from "./ProjectNavigation.vue?vue&type=script&lang=ts"
export * from "./ProjectNavigation.vue?vue&type=script&lang=ts"
import style0 from "./ProjectNavigation.vue?vue&type=style&index=0&id=131f7e45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131f7e45",
  null
  
)

export default component.exports